<template>
  <div class="full" style="padding: 1rem;overflow-y: auto;">
    <Card :bordered="false" class="approvalContainer mb1" dis-hover>
      <div class="detailTitleContainer">
        <div class="detailTitle">
          <Icon type="md-create" />
          当前节点【{{curTaskName || '--'}}】
        </div>
      </div>
      <div style=" padding: 1rem 2rem 0 1rem">
        <Form :label-width="100" :model="baseData" label-position="right">
          <FormItem label="审批信息" prop="commentInfo">
            <Input
              :autosize="{minRows: 3,maxRows: 6}"
              clearable
              maxlength="255"
              show-word-limit
              type="textarea"
              v-model="baseData.commentInfo"
            ></Input>
          </FormItem>
          <FormItem label="审批附件" prop="commentInfo">
            <Upload
              :action="fileUpload"
              :before-upload="beforeUpload"
              :data="otherData"
              :headers="headers"
              :max-size="1024 * maxSize"
              :on-error="handleError"
              :on-exceeded-size="handleMaxSize"
              :on-remove="deleteAttachmentsFile"
              :on-success="handleAttachmentsSuccess"
              style="width: 100%"
              type="drag"
              v-model="baseData.attachments"
            >
              <div style="padding: 20px 0">
                <Icon size="52" style="color: #3399ff" type="ios-cloud-upload"></Icon>
                <p style="color:#ccc; font-size: 0.6rem">点击或将文件拖拽到这里上传</p>
              </div>
            </Upload>
          </FormItem>
          <FormItem label prop="checkData">
            <CheckboxGroup @on-change="changeAssign" v-model="baseData.checkData">
              <Checkbox label="assignUser">
                <span>指定下一步处理者(不设置就使用默认处理人)</span>
              </Checkbox>
            </CheckboxGroup>
            <Select
              filterable
              placeholder="请选择用户"
              v-if="showSelect"
              v-model="baseData.customAssignUser"
            >
              <Option
                :key="item.value+'userOption'"
                :value="item.value"
                v-for="item in userOptions"
              >{{ item.label }}</Option>
            </Select>
          </FormItem>
        </Form>
        <Divider dashed orientation="left" v-if="formData && Object.keys(formData).length > 0">审批表单</Divider>
        <Form :label-width="120" :model="formData" label-position="right" ref="formData">
          <FormItem
            :key="key"
            :label="otherParams[key].name"
            :prop="key"
            :rules="formDataRules[key]"
            v-for="(item, key) in formData"
            v-show="otherParams[key].readable"
          >
            <Input
              :disabled="otherParams[key].writeable?false:true"
              clearable
              type="text"
              v-if="otherParams[key].type == 'string'"
              v-model="formData[key]"
            ></Input>
            <Input
              :disabled="otherParams[key].writeable?false:true"
              type="number"
              v-if="otherParams[key].type == 'long' || otherParams[key].type == 'double'"
              v-model="formData[key]"
            ></Input>
            <DatePicker
              :disabled="otherParams[key].writeable?false:true"
              :format="otherParams[key].datePattern || 'yyyy-MM-dd HH:mm:dd'"
              @on-change="(formatDate, type) => {changeDate(formatDate, type, key)}"
              class="autoWidth"
              clearable
              style="width: 100%"
              transfer
              type="datetime"
              v-else-if="otherParams[key].type == 'date'"
              v-model="formData[key]"
            ></DatePicker>
            <i-switch
              :disabled="otherParams[key].writeable?false:true"
              v-else-if="otherParams[key].type == 'boolean'"
              v-model="formData[key]"
            >
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
            <Select v-else-if="otherParams[key].type == 'enum'" v-model="formData[key]">
              <Option
                :key="keySub+'-enum'"
                :value="keySub"
                v-for="(option, keySub) in otherParams[key].formValues"
                v-if="otherParams[key].formValues"
              >{{option || '--'}}</Option>
            </Select>
            <Upload
              :action="fileUpload"
              :before-upload="beforeUpload"
              :data="otherData"
              :disabled="otherParams[key].writeable?false:true"
              :headers="headers"
              :max-size="1024 * maxSize"
              :on-error="handleError"
              :on-exceeded-size="handleMaxSize"
              :on-remove="(file, fileList) => {deleteFile(file, fileList,key)}"
              :on-success="(res, file) => {handleSuccess(res, file, key)}"
              style="width: 100%"
              type="drag"
              v-else-if="otherParams[key].type == 'file'"
              v-model="formData[key]"
            >
              <div style="padding: 20px 0">
                <Icon size="52" style="color: #3399ff" type="ios-cloud-upload"></Icon>
                <p style="color:#ccc; font-size: 0.6rem">点击或将文件拖拽到这里上传</p>
              </div>
            </Upload>
          </FormItem>
        </Form>
      </div>
      <div class="todoFooter">
        <Button :disabled="hiddenBtnoPts" @click="backTask" type="primary">指定回退</Button>
        <Button
          :disabled="hiddenBtnoPts"
          @click="delegateTask"
          type="primary"
          v-if="showDelegateBtn"
        >委派</Button>
        <Button :disabled="hiddenBtnoPts" @click="submit" type="primary">确定</Button>
        <Button :disabled="hiddenBtnoPts" @click="terminationTask" type="error">作废</Button>
      </div>
    </Card>
    <Card :bordered="false" dis-hover>
      <Tabs :value="type" @on-click="changeStatus">
        <TabPane
          :index="1"
          :v-if="baseData.hasStartForm && formData && Object.keys(formData).length > 0"
          label="表单信息"
          name="form"
        ></TabPane>
        <TabPane :index="2" label="流转记录" name="histroy"></TabPane>
        <TabPane :index="3" label="流程图" name="image"></TabPane>
      </Tabs>
      <div>
        <div v-if="type == 'form'">
          <Form
            :label-width="140"
            :model="startFormData"
            label-position="right"
            ref="startFormData"
          >
            <FormItem
              :key="item.key"
              :label="item.name"
              :prop="item.key"
              v-for="(item, index) in formProperties"
              v-show="item.readable"
            >
              <Input
                disabled
                type="text"
                v-if="item.type == 'string'"
                v-model="startFormData[item.key]"
              ></Input>
              <Input
                disabled
                type="number"
                v-if="item.type == 'long' || item.type == 'double'"
                v-model="startFormData[item.key]"
              ></Input>
              <DatePicker
                :format="item.datePattern || 'yyyy-MM-dd HH:mm:dd'"
                @on-change="(formatDate, type) => {changeStartFormDate(formatDate, type, key)}"
                class="autoWidth"
                clearable
                disabled
                style="width: 100%"
                type="datetime"
                v-else-if="item.type == 'date'"
                v-model="startFormData[item.key]"
              ></DatePicker>
              <i-switch
                disabled
                v-else-if="item.type == 'boolean'"
                v-model="startFormData[item.key]"
              >
                <span slot="open">是</span>
                <span slot="close">否</span>
              </i-switch>
              <Select disabled v-else-if="item.type == 'enum'" v-model="startFormData[item.key]">
                <Option
                  :key="keySub+'-enum'"
                  :value="keySub"
                  v-for="(option, keySub) in item.formValues"
                  v-if="item.formValues"
                >{{option || '--'}}</Option>
              </Select>
              <div v-else-if="item.type == 'file'">
                <div v-if="startFormData[item.key]">
                  {{JSON.parse(startFormData[item.key])}}
                  <div
                    :key="file.fileName"
                    @click="dowmLoadFile(file)"
                    class="downloadFileBtn"
                    v-for="file in JSON.parse(startFormData[item.key])"
                  >{{file.fileName}}</div>
                </div>
                <div v-else>未上传文件</div>
              </div>
            </FormItem>
          </Form>
        </div>
        <div v-else-if="type == 'histroy'">
          <Timeline style="padding: 1rem 2rem">
            <TimelineItem
              :key="index + 'timeItem'"
              color="blue"
              v-for="(timeItem, index) in timelineData"
            >
              <Icon
                :color="timeItem.endTime != undefined? 'blue' : 'red'"
                slot="dot"
                type="md-arrow-dropright-circle"
                v-if="index == 0"
              ></Icon>
              <span>{{timeItem.startTime}}</span>
              <Card>
                <div class="timeItemTitle">{{timeItem.taskName}}</div>
                <div class="timelineItemBaseInfo">
                  <div>
                    <div>办理人:</div>
                    <div>办理状态:</div>
                    <div>审批意见:</div>
                    <div v-if="timeItem.attachments">审批附件</div>
                    <div>开始时间:</div>
                    <div>结束时间:</div>
                    <div>用时:</div>
                  </div>
                  <div>
                    <div>{{timeItem.approveUserName || '--'}}</div>
                    <div>
                      <Tag color="primary" v-if="timeItem.status == 'START'">开始</Tag>
                      <Tag color="error" v-else-if="timeItem.status == 'DELETE'">作废流程</Tag>
                      <Tag color="success" v-else-if="timeItem.status == 'FINISH'">审核结束</Tag>
                      <Tag color="primary" v-else-if="timeItem.status == 'RUN'">待审核</Tag>
                      <div v-else>--</div>
                    </div>
                    <div>{{timeItem.suggestion || '--'}}</div>
                    <div v-if="timeItem.attachments">
                      <a
                        :key="attachment.fileName+'-attachment'"
                        @click="dowmLoadFile(attachment)"
                        v-for="(attachment, index) in timeItem.attachments"
                      >
                        {{attachment.fileName}}
                        <span
                          v-if="index < (timeItem.attachments.length -1)"
                        >、</span>
                      </a>
                    </div>
                    <div>{{timeItem.startTime || '--'}}</div>
                    <div>{{timeItem.endTime || '--'}}</div>
                    <div>{{timeItem.duration || '--'}}</div>
                  </div>
                </div>
              </Card>
            </TimelineItem>
          </Timeline>
        </div>
        <div v-else-if="type == 'image'">
          <img :src="flowImgId" style="width: 100%;height: auto;max-width: 100%" />
        </div>
      </div>
    </Card>
    <Modal :title="deleteForm.title" v-model="showDelete">
      <Form :labelWidth="120" :model="deleteForm" label-position="right" ref="deleteForm">
        <FormItem
          :rules="[{required: true, message: '请输入作废原因', trigger: 'change'}]"
          label="作废原因"
          prop="reason"
        >
          <Input
            :autosize="{minRows: 3,maxRows: 6}"
            clearable
            maxlength="255"
            placeholder="请输入作废原因"
            show-word-limit
            type="textarea"
            v-model="deleteForm.reason"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="cancelDelete">取消</Button>
        <Button @click="submitDelete" type="primary">确定</Button>
      </div>
    </Modal>
    <Modal :title="delegateForm.title" v-model="showDelegate">
      <Form
        :labelWidth="120"
        :model="delegateForm"
        :rules="delegateFormValidate"
        label-position="right"
        ref="delegateForm"
      >
        <FormItem class="m5" label="委派对象" prop="delegateUser">
          <Select filterable v-model="delegateForm.delegateUser">
            <Option
              :key="item.value+'delegateUserOption'"
              :value="item.value"
              v-for="item in userOptions"
            >{{ item.label }}</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="cancelDelegate">取消</Button>
        <Button @click="submitDelegate" type="primary">确定</Button>
      </div>
    </Modal>
    <Modal :title="backTaskForm.title" v-model="showBackTask">
      <Form
        :labelWidth="120"
        :model="backTaskForm"
        :rules="backTaskFormValidate"
        label-position="right"
        ref="backTaskForm"
      >
        <FormItem class="m5" label="退回节点" prop="backTask">
          <Select filterable v-model="backTaskForm.backTask">
            <Option
              :key="item.id+'-backTask'"
              :value="item.id"
              v-for="item in userTaskList"
            >{{ item.name || item.id }}</Option>
          </Select>
        </FormItem>
        <FormItem class="m5" label="理由" prop="reason">
          <Input
            :autosize="{minRows: 3,maxRows: 6}"
            clearable
            maxlength="255"
            show-word-limit
            type="textarea"
            v-model="backTaskForm.reason"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="cancelBackTask">取消</Button>
        <Button @click="submitBackTask" type="primary">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import utils from '@/libs/utils'
export default {
  name: 'todoHandler',
  props: {
    taskId: '',
    processInstanceId: '',
    name: {
      required: false,
      type: String
    }
  },
  data () {
    return {
      //隐患所需数据
      hasRepetition: false,
      hiddenBtnoPts: false,
      // hiddenStatus:{},

      maxSize: fileMaxSize,
      showDelegate: false,
      showDelete: false,
      showBackTask: false,
      type: 'histroy',

      flowImgId: '',
      timelineData: [],
      formProperties: [],
      startFormData: {},
      fileUpload: process.env.VUE_APP_API_ROOT + this.$apis.workflowMgr.myaffairs.startProcess.uploadProcessVariablesFile,
      getFile: process.env.VUE_APP_API_ROOT + this.$apis.workflowMgr.myaffairs.startProcess.getProcessVariablesFile,
      headers: {
        Authorization: utils.getToken()
      },
      fileList: [],
      formData: {},
      itemParams: [],
      otherParams: {},
      userOptions: [],
      baseData: {
        hasStartForm: false,
        commentInfo: '',
        checkData: [],
        assignUser: false,
        customAssignUser: ''
      },
      showSelect: false,
      curTaskName: '',
      deleteForm: {
        title: '',
        processInstanceId: '',
        reason: ''
      },
      delegateForm: {
        title: '',
        processInstanceId: '',
        delegateUser: ''
      },
      delegateFormValidate: {
        delegateUser: [{ required: true, message: "请选择委派对象", trigger: 'change' }],
      },
      showDelegateBtn: false,
      backTaskFormValidate: {
        backTask: [{ required: true, message: "请选择退回节点", trigger: 'change' }],
        reason: [{ required: true, message: "请输入退回理由", trigger: 'blur' }],
      },
      backTaskForm: {
        reason: ''
      },
      userTaskList: []
    }
  },
  computed: {
    otherData () {
      return { processId: this.processInstanceId + "/" + this.taskId }
    },
    formDataRules () {
      let roules = {}
      this.itemParams.forEach(item => {
        if (item.required) {
          if (item.type == 'date') {
            roules[item.id] = [{ required: item.required, validator: this.ruleDate, message: '日期不能为空!', trigger: 'blur', pattern: /.+/ }]
          } else if (item.type == 'boolean') {
            roules[item.id] = [{ required: item.required, validator: this.ruleBoolean, message: '不能为空!', type: 'boolean', pattern: /^(true)|(false)$/, trigger: 'change' }]
          } else if (item.type == 'long' || item.type == 'double') {
            roules[item.id] = [{ required: item.required, validator: this.ruleEmpty, type: 'number', message: '不能为空', trigger: 'blur' }]
          } else if (item.type == 'enum') {
            roules[item.id] = [{ required: item.required, validator: this.ruleEmpty, message: '不能为空', trigger: 'change', pattern: /.+/ }]
          } else if (item.type == 'file') {
            roules[item.key] = [{ required: item.required, validator: this.ruleEmpty, message: '不能为空', trigger: 'change' }]
          } else {
            roules[item.id] = [{ required: item.required, validator: this.ruleEmpty, message: '不能为空', trigger: 'blur' }]
          }
        }
      })
      return roules
    }
  },
  methods: {
    changeAssign: function (params) {
      if (params.indexOf('assignUser') >= 0) {
        this.baseData.assignUser = true
        this.showSelect = true
      } else {
        this.baseData.assignUser = false
        this.showSelect = false
      }

    },
    getUserOptions: function () {
      let that = this
      this.$axios.post(this.$apis.workflowMgr.model.process.getUsers).then(res => {
        if (res.success) {
          that.userOptions = res.result || []
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error('获取用户列表失败！')
      })
    },
    dowmLoadFile: function (file) {
      this.$axios.post(this.$apis.workflowMgr.model.process.getFileWithPath + "?filePath=" + file.filePath, null, { responseType: 'blob' }).then(val => {
        let url = window.URL.createObjectURL(new Blob([val.data]))
        let link = document.createElement('a')
        link.id = "mocDownload"
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', file.fileName)
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
        document.body.removeChild(link)
      }).catch(err => {
        console.log(err)
        this.$Message.error("获取文件失败！")
      })
    },
    loadHisData: function () {
      let that = this
      this.$axios.post(that.$apis.workflowMgr.monitor.getProcessInstanceDetail + "?processInstanceId=" + this.processInstanceId).then(res => {
        if (res.success) {
          let result = res.result || {}
          that.timelineData = result.timeLine || []
          that.baseData.name = result.name || ''
          that.baseData.status = result.status || ''
          that.formProperties = result.formProperties || []
          that.baseData.hasStartForm = result.hasStartForm || false
          let data = result.startFormData || {}
          that.formProperties.forEach(formProperties => {
            if (formProperties.type == 'date' && data[formProperties.key]) {
              that.startFormData[formProperties.key] = new Date(data[formProperties.key])
            } else {
              that.startFormData[formProperties.key] = data[formProperties.key]
            }

          })
          that.timelineData.forEach(element => {
            element.startTime = that.$common.getDate(element.startTime)
            element.endTime = that.$common.getDate(element.endTime)
          })
        } else {
          that.$Message.error(res.message)
        }
      }).catch(function (err) {
        that.$Message.error('流程详情获取失败！')
      }).then(val => {
        if (that.baseData.hasStartForm) {
          that.type = 'form'
        }
      })
    },
    changeStatus: function (name) {
      this.type = name
      if ("image" == name) {
        this.flowImgId = process.env.VUE_APP_API_ROOT + this.$apis.workflowMgr.model.process.getImage + "?processInstanceId=" + this.processInstanceId
      } else {
      }
    },
    beforeUpload: function () {
      return true
    },
    handleSuccess (res, file, key) {
      if (this.formData[key]) {
        this.formData[key] = JSON.parse(this.formData[key])
      } else {
        this.formData[key] = []
      }
      if (res.status === this.$common.resCode.SUCCESS) {
        this.formData[key].push({ fileName: file.name, filePath: res.result })
      } else {
        // this.$Message.error(res.message)
      }
      this.formData[key] = JSON.stringify(this.formData[key])
    },
    deleteFile: function (file, fileList, key) {
      this.formData[key] = []
      fileList.forEach(file => {
        this.formData[key].push({ fileName: file.name, filePath: file.response.result })
      })
      this.formData[key] = JSON.stringify(this.formData[key])
    },
    handleAttachmentsSuccess: function (res, file, key) {
      if (this.baseData.attachments) {
        this.baseData.attachments = JSON.parse(this.baseData.attachments)
      } else {
        this.baseData.attachments = []
      }
      if (res.success) {
        this.baseData.attachments.push({ fileName: file.name, filePath: res.result })
      } else {
        // this.$Message.error(res.message)
      }
      this.baseData.attachments = JSON.stringify(this.baseData.attachments)
    },
    deleteAttachmentsFile: function (file, fileList) {
      this.baseData.attachments = []
      fileList.forEach(file => {
        this.baseData.attachments.push({ fileName: file.name, filePath: file.response.result })
      })
      this.baseData.attachments = JSON.stringify(this.baseData.attachments)
    },
    handleMaxSize (file) {
      this.$Message.error('上传文件不超过' + this.maxSize + 'M！')
    },
    handleError (res) {
      this.$Message.error('文件上传失败！')
    },
    ruleBoolean: function (rule, value, callback) {
      if (value == undefined || value == null) {
        callback("不能为空")
      } else {
        callback()
      }
    },
    ruleDate: function (rule, value, callback) {
      if (value == undefined || value == null) {
        callback("不能为空")
      } else {
        callback()
      }
    },
    ruleEmpty: function (rule, value, callback) {
      if (value == undefined || value == null || value == '' || value.trim() == '') {
        callback("不能为空")
      } else {
        callback()
      }
    },
    changeDate: function (formatDate, type, key) {
      this.formData[key] = formatDate
    },
    changeStartFormDate: function (formatDate, type, key) {
      this.startFormData[key] = formatDate
    },
    loadDetail: function () {
      this.getUserOptions()
      this.loadHisData()
      let that = this
      this.otherParams = {}
      this.formData = {}
      let params = new this.$URLSearchParams()
      params.append("taskId", this.taskId)
      params.append("processInstanceId", this.processInstanceId)
      this.$axios.post(that.$apis.workflowMgr.myaffairs.todo.getTaskForm, params).then(res => {
        if (res.success) {
          let result = res.result || {}
          that.itemParams = result.formProperties || []
          that.curTaskName = result.taskName || ''
          that.showDelegateBtn = result.delegationState ? false : true
          if (result.assignedUser) {
            that.baseData.customAssignUser = result.assignedUser
            that.baseData.checkData = ['assignUser']
            that.showSelect = true
          }
          let variables = result.variables || {}
          let data = {}
          that.itemParams.forEach(item => {
            that.otherParams[item.id] = item
            if (item.type == 'date') {
              data[item.id] = (item.value == undefined || item.value == null) ? (variables[item.id] || item.defaultExpression) : item.value
            } else if (item.type == 'boolean') {
              data[item.id] = (item.value == undefined || item.value == null) ? (variables[item.id] || (item.defaultExpression == 'true' || item.defaultExpression == '1' ? true : false)) : item.value
            } else if (item.type == 'long' || item.type == 'double') {
              data[item.id] = (item.value == undefined || item.value == null) ? (variables[item.id] || item.defaultExpression) : item.value
            } else {
              data[item.id] = (item.value == undefined || item.value == null) ? (variables[item.id] || item.defaultExpression) : item.value
            }
          })
          that.formData = Object.assign({}, data)
          that.showCheckPage = true
        } else {
          //that.$Message.error(res.message);
        }
      }).catch(function (err) {
        console.log(err)
        that.$Message.error('获取表单失败！')
      })
    },
    backList: function () {
      this.$emit('close')
      // this.$router.push({path: '/myAffairsTodo'})
    },
    submit: function () {
      let that = this
      try {
        this.$refs["formData"].validate(valid => {
          if (valid) {
            let params = new this.$URLSearchParams
            that.baseData.taskId = that.taskId
            that.baseData.processInstanceId = that.processInstanceId
            params.append('baseDataJSONString', JSON.stringify(that.baseData))
            params.append('variablesJSONString', JSON.stringify(that.formData))
            that.$axios.post(that.$apis.workflowMgr.myaffairs.todo.submitForm, params).then(res => {
              if (res.success) {
                that.$Message.success("保存成功！")
                that.backList()
              } else {
                that.$Message.error(res.message)
              }
            }).catch(function (err) {
              that.$Message.error("保存失败！")
            })
          } else {
            console.log("validator fail")
            return false
          }
        })
      } catch (e) {
        console.log("validator error", e)
      }
    },
    backTask: function () {
      //指定驳回任务
      let params = new this.$URLSearchParams()
      params.append("taskId", this.taskId)
      this.$axios.post(this.$apis.workflowMgr.myaffairs.todo.findReturnUserTask, params).then(res => {
        if (res.status === this.$common.resCode.SUCCESS) {
          this.userTaskList = res.result || []
        } else {
          this.$Message.error(res.message)
        }
      }).catch(function (err) {
        this.$Message.error('作废失败！')
      })
      this.showBackTask = true
      this.backTaskForm.title = '当前节点【' + (this.curTaskName || '--') + '】'

    },
    delegateTask: function () {
      //委派
      this.showDelegate = true
      this.delegateForm = {}
      this.delegateForm.title = this.baseData.name
      this.delegateForm.delegateUser = ''
    },
    submitDelegate: function () {
      let that = this
      this.$refs["delegateForm"].validate(valid => {
        if (valid) {
          let params = new this.$URLSearchParams()
          params.append("delegateUser", this.delegateForm.delegateUser)
          params.append("processInstanceId", this.processInstanceId)
          params.append("taskId", this.taskId)
          this.$axios.post(that.$apis.workflowMgr.myaffairs.todo.delegateTask, params).then(res => {
            if (res.success) {
              that.backList()
            } else {
              that.$Message.error(res.message)
            }
          }).catch(function (err) {
            that.$Message.error('作废失败！')
          })
        } else {
          return false
        }
      })
    },
    cancelDelegate: function () {
      this.delegateForm = {}
      this.showDelegate = false
      this.$refs["delegateForm"].resetFields()
    },
    terminationTask: function () {
      //终止任务
      this.deleteForm.reason = ''
      this.deleteForm.title = this.baseData.name
      this.showDelete = true
    },
    submitDelete: function () {
      let that = this
      this.$refs["deleteForm"].validate(valid => {
        if (valid) {
          let params = new this.$URLSearchParams()
          params.append("reason", this.deleteForm.reason)
          params.append("processInstanceId", this.processInstanceId)
          this.$axios.post(that.$apis.workflowMgr.monitor.deleteProcess, params).then(res => {
            if (res.success) {
              that.backList()
            } else {
              that.$Message.error(res.message)
            }
          }).catch(function (err) {
            that.$Message.error('提交失败！')
          })
        } else {
          return false
        }
      })
    },
    cancelDelete: function () {
      this.deleteForm = {}
      this.showDelete = false
      this.$refs["deleteForm"].resetFields()
    },
    cancelBackTask: function () {
      this.backTaskForm = {}
      this.showBackTask = false
      this.$refs["backTaskForm"].resetFields()
    },
    submitBackTask: function () {
      let that = this
      this.$refs["backTaskForm"].validate(valid => {
        if (valid) {
          let params = new this.$URLSearchParams()
          params.append("taskId", this.taskId)
          params.append("targetKey", this.backTaskForm.backTask)
          params.append("reason", this.backTaskForm.reason)
          this.$axios.post(that.$apis.workflowMgr.myaffairs.todo.flowReturn, params).then(res => {
            if (res.success) {
              that.$Message.success('回退成功')
              that.backList()
            } else {
              that.$Message.error(res.message)
            }
          }).catch(function (err) {
            that.$Message.error('回退失败！')
          })
        } else {
          return false
        }
      })
    },
    getHiddenDetail: function (processInstanceId) {
      //只有是隐患审核的时候才触发 (查询隐患审核状态)
      let params = new this.$URLSearchParams()
      params.append("processInstanceId", processInstanceId)
      this.$axios.post(this.$apis.inventory.getHiddenList, params)
        .then(res => {
          if (res.success) {
            this.getIsWrite(processInstanceId, res.result)
          } else {
            this.$Message.error(res.message)
          }
        }).catch(function (err) {
          this.$Message.error('获取隐患详情失败！')
        })
    },
    getIsWrite: function (processInstanceId, data) {
      //只有是隐患审核的时候才触发 (查询是否有重复的)
      let params = new this.$URLSearchParams()
      params.append("processInstanceId", processInstanceId)
      this.$axios.post(this.$apis.inventory.getIsWrite, params)
        .then(res => {
          if (res.success) {
            this.hasRepetition = res.result
            this.hiddenBtnoPts = (data.submitStatus == false && data.processStatus == 'RECTIFYING') || (data.processStatus == 'RECHECKING' && this.hasRepetition == true) || (data.processStatus == 'ACCEPTING' && this.hasRepetition == true)
            console.log(this.hiddenBtnoPts)
          } else {
            this.$Message.error(res.message)
          }
        }).catch(function (err) {
          this.$Message.error('获取重复信息失败！')
        })
    },
  },
  beforeMount () {
    this.loadDetail()
    if (this.name == 'hidden') {
      this.getHiddenDetail(this.processInstanceId)
    }
  }
}
</script>
<style scoped>
.approvalContainer {
  background: #fff;
  /* padding: 0 2rem; */
  margin-bottom: 1rem;
}
.approvalContainerTitle {
  border-bottom: 1px solid #dcdee2;
  padding: 10px;
  margin-bottom: 10px;
}
.todoFooter {
  text-align: center;
  padding: 10px;
  width: 100%;
  border-top: 1px solid #dcdee2;
}
.downloadFileBtn {
  cursor: pointer;
  color: #57a3f3;
}
.timeItemTitle {
  font-size: 0.9rem;
  font-weight: 600;
  color: #333;
  line-height: 2rem;
}
.timelineItemBaseInfo {
  background: #ebf8ff;
  border-radius: 4px;
  border-left: 5px solid #50bfff;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  line-height: 2rem;
}

.timelineItemBaseInfo > div:first-child {
  white-space: nowrap;
  width: auto;
  padding: 0 10px;
  text-align: right;
}
.timelineItemBaseInfo > div:last-child {
  flex-grow: 1;
}
</style>